import styles from "./index.module.scss";
import { useContext,useState } from "react";
import ChangeLanguageFunctions from "@/contexts/changeLanguageContext";
import { Radio, Tooltip } from "antd";
import enImg from "@/assets/images/en.png";
import cnImg from "@/assets/images/cn.png";
const ChangeLang = () => {
	const ctx = useContext(ChangeLanguageFunctions)
	let lang = localStorage.getItem('lang') || 'zh-CN'
	const [type, setType] = useState(lang);

	const handleLangChange = (lang) => {
		ctx.changeLang(lang)
		setType(lang)
	}
	return (
		<div className={styles.lang}>
			<Tooltip title={lang === 'en-US' ? '切换中文' : 'Switch English'}>
				{type==="zh-CN"&&<img src={enImg} onClick={()=>handleLangChange('en-US')}/>}
				{type==="en-US"&&<img src={cnImg} onClick={()=>handleLangChange('zh-CN')}/>}
			</Tooltip>

		</div>
	)
}
export default ChangeLang;
